import React from "react";
// import PropTypes from "prop-types";
import Helmet from "react-helmet";

/*  */
const LayoutHead = ({ children }) => (
  <Helmet
    title="The State of European Tech 2017"
    meta={[
      { name: "description", content: "The State of European Tech 2017" },
      { name: "keywords", content: "atomico, european tech" }
    ]}
  >
    <html lang="en" />
    {children}
  </Helmet>
);

export default LayoutHead;



// WEBPACK FOOTER //
// ./src/components/LayoutHead/index.js